<template>
  <div class="container">
    <div
      id="page1-div"
      class="container interline border page-container"
    >
      <div class="col-12 p-5">
        <div class="col-12 text-center pt-5 pb-4">
          <u class="ft12Black">CARTA DE INSTRUCCIÓN DE PAGO A TERCERO</u>
        </div>
        <div class="col-12 text-right">
          <span class="ft11">
            CD, <span v-bind:class="{ marca: data.showMarca }">
              {{ data.municipio_cliente }}</span
            >,
            <span v-bind:class="{ marca: data.showMarca }">
              {{ data.estado_cliente }}</span>, a
            <span v-bind:class="{ marca: data.showMarca }">
              {{ data.fecha_contrato }}.
            </span>
          </span>
        </div>
        <div class="col-12 text-justify pt-4">
          <span class="ft10">
            Apoderado o Representante Legal de <br />
            GPI AUTO COMERCIAL SAPI DE C.V. <br />
            <br />
            Con referencia al contrato de apertura de crédito simple con
            garantía prendaria sin transmisión de la posesión, celebrado el día
            <span v-bind:class="{ marca: data.showMarca }">
              {{ data.fecha_contrato }}
            </span>
            (en adelante el "CONTRATO"), entre el
            suscrito y su representada, me permito: Autorizar e instruir para
            que, en mi nombre y representación, entreguen la cantidad de
            <span v-bind:class="{ marca: data.showMarca }">
              ${{ data.monto_a_finaciar_sin_seguro }}</span
            >, el cual corresponde al Importe del Crédito derivado del
            Contrato, a
            <span class="ft10Black" v-bind:class="{ marca: data.showMarca }">
              {{ data.pago_tercero }}
            </span>
           en su carácter de Proveedor,
            mediante cheque o transferencia bancaria a la cuenta que determine
            éste último, toda vez que con dicha sociedad he convenido la
            adquisición del Bien, en cumplimiento a lo estipulado en el
            Contrato. El Acreditado y el Acreditante convienen en que éste
            último, de acuerdo con lo establecido en el Contrato recibe en
            prenda sin transmisión de la posesión el Bien, referido en la
            factura

            <span v-bind:class="{ marca: data.showMarca }">
              {{ data.numero_factura }}
            </span>
            DEL
            <span v-bind:class="{ marca: data.showMarca }">
              {{ data.fecha_factura }}, </span
            > emitida por
            <span v-bind:class="{ marca: data.showMarca }">
              {{ data.emisor_factura }},
            </span>
             incluyendo las siguientes características e información:
            <br />
            <br />
            Descripción de Vehículo: <br />
            Marca:
            <span v-bind:class="{ marca: data.showMarca }">
              {{ data.marca_vehiculo }}
            </span>
            <br />
            Año:
            <span v-bind:class="{ marca: data.showMarca }">
              {{ data.año_vehiculo }}
            </span>
            <br />
            Modelo:
            <span v-bind:class="{ marca: data.showMarca }">
              {{ data.modelo_vehiculo }}
            </span>
            <br />
            Número de Motor:
            <span v-bind:class="{ marca: data.showMarca }">
              {{ data.numero_motor_vehiculo }}
            </span>
            <br />
            Número de Serie:
            <span v-bind:class="{ marca: data.showMarca }">
              {{ data.numero_serie_vehiculo }}
            </span>
            <br /> <br />
            Asi como el original de la factura antes mencionada, materia del
            presente contrato, hasta que el precio pactado y derivaciones
            legales estén totalmente pagados.
            <br />
            <br />
            Además, certifico que he leído y firmado el contrato de préstamo, el
            pagaré correspondiente, el convenio de aceptación del vehículo en
            las condiciones en que se encuentra, el endoso de la factura
            original, la entrega de las últimas tenencias, el último pago de
            placas, y he recibido el número de la cuenta bancaria referenciada
            en donde debo hacer los pagos en los vencimientos estipulados,
            también ha quedado debidamente asegurado el vehículo, con póliza de
            su empresa e instalado el sistema inmovilizador.
          </span>
        </div>
        <div class="col-12 row p-5">
          <div class="col-3 text-center"></div>
          <div class="col-6 border-dark text-center">
            <span class="ft11">
              ATENTAMENTE
            </span>
          </div>
          <div class="col-3 text-center"></div>
        </div>
        <div v-if="!data.tipoObligadoAval" class="col-12 row ">
          <div class="col-3 text-center"></div>
          <div class="col-6 border-bottom border-dark text-center">
            <span v-bind:class="{ marca: data.showMarca }" class="ft11 ">
              {{ data.nombre_cliente }}
            </span>
          </div>
          <div class="col-3 text-center"></div>
        </div>
        <div v-if="!data.tipoObligadoAval" class="col-12 row ">
          <div class="col-3 text-center"></div>
          <div class="col-6 text-center pt-3">
            <span class="ft11">
              NOMBRE Y FIRMA DEL ACREDITADO <br /><br /><br /><br /><br /><br />
            </span>
          </div>
          <div class="col-3 text-center"></div>
        </div>
        <div v-if="data.tipoAval" class="col-12 row ">
          <div class="col-3 text-center"></div>
          <div class="col-6 border-bottom border-dark text-center">
            <span class="ft11">
              <span v-bind:class="{ 'marca-aval': data.showMarca }">
                {{ data.nombre_aval }}
              </span>
            </span>
          </div>
          <div class="col-3 text-center"></div>
        </div>
        <div v-if="data.tipoAval" class="col-12 row ">
          <div class="col-3 text-center"></div>
          <div class="col-6 text-center pt-3">
            <span class="ft11">
              NOMBRE Y FIRMA DEL AVAL Y OBLIGADO SOLIDARIO
            </span>
          </div>
          <div class="col-3 text-center"></div>
        </div>
        <div v-if="data.tipoObligado" class="col-12 row ">
          <div class="col-3 text-center"></div>
          <div class="col-6 border-bottom border-dark text-center">
            <span class="ft11">
              <span v-bind:class="{ 'marca-obligado': data.showMarca }">
                {{ data.nombre_obligado }}
              </span>
            </span>
          </div>
          <div class="col-3 text-center"></div>
        </div>
        <div v-if="data.tipoObligado" class="col-12 row ">
          <div class="col-3 text-center"></div>
          <div class="col-6 text-center pt-3">
            <span class="ft11">
              NOMBRE Y FIRMA DEL AVAL Y OBLIGADO SOLIDARIO
            </span>
          </div>
          <div class="col-3 text-center"></div>
        </div>

        <div v-if="data.tipoObligadoAval" class=" col-12 row pt-4">
            <div class="col-5 offset-1  border-top border-dark text-center">
              <span class="ft9">
                DEUDOR / SUSCRIPTOR <br>
              </span>
              <span  class="ft11 text-justify">
                {{ data.nombre_cliente }}
              </span>
            </div>
            <div class="col-5 offset-1 border-top border-dark text-center">
              <span class="ft9">
                AVAL Y OBLIGADO SOLIDARIO<br>
              </span>
              <span  class="ft11 text-justify">
                {{ data.nombre_aval }}
              </span>
            </div>
            <br><br><br><br><br><br><br><br><br>
            <div class="col-5 offset-4 border-top border-dark text-center">
              <span class="ft9">
                AVAL Y OBLIGADO SOLIDARIO<br>
              </span>
              <span  class="ft11 text-justify">
                {{ data.nombre_obligado }}
              </span>
            </div>
        </div>


      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "IntruccionPAgoTErceros",
  data() {
    return {};
  },
  validations() {
    return {};
  },
  props: {
    data: {
      type: Object
    }
  },
  methods: {},
  created() {
    window.scrollTo(0, 0);
  }
};
</script>
<style type="text/scss">
@import "../style.scss";
</style>



// WEBPACK FOOTER //
// src/views/Contratos/cartas/InstruccionPagoTerceros.vue